import { render, staticRenderFns } from "./SupplierTypes.vue?vue&type=template&id=0767eff2&scoped=true&"
import script from "./SupplierTypes.vue?vue&type=script&lang=js&"
export * from "./SupplierTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0767eff2",
  null
  
)

export default component.exports